<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  .u-mt-md(v-for="item,idx in $t('insights')")
    span
      AppSection(:class="{'is-reversed': idx % 2 === 0}" :img="[{ srcset: `{CDN_URL}/insights/${idx}@2x.webp 2x, {CDN_URL}/insights/${idx}.webp 1x`, type: 'image/webp' },  { srcset: `{CDN_URL}/insights/${idx}@2x.png 2x, {CDN_URL}/insights/${idx}.png 1x`, type: 'image/png' }]" :imgAlt="item.title")
        h3 {{item.title}}
        p {{item.desc}}


  .u-mb-md
</template>

<script>
export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Manifesto",
    "pageDesc":"Learning from the past and reflecting on the future. Our deeply held insights and principles that formed Baianat vision.",
    "mantra":"Deeply held insights |and principles.",
    "insights":{
      "1":{
        "title":"One who has no morals, has no knowledge.",
        "desc":"A Business that is not built on morals and ethics is fragile and liable to distortion. Knowledge will come in a way or another, but if it came in a corrupted environment, it won't function as it must do."
      },
      "2":{
        "title":"Success comes with a paycheck.",
        "desc":"What every player needs to understand is that persistence sometimes is more important than skills and with great successes comes great sacrifices."
      },
      "3":{
        "title":"Time is not gold, it’s much more expensive.",
        "desc":"Today is never like tomorrow or the next year. Things are always changing and evolving, so you don't have to wait for the perfect moment. Just start now."
      },
      "4":{
        "title":"For every problem there is a solution and an IDEAL solution.",
        "desc":"Problems are not as important as your attitude toward them. All problems have solutions that might come to our mind when we start thinking, but we always seek the perfect solution, the one that leaves no trace to the problem, we solve the problem at its roots because we don't accept half-solutions."
      },
      "5":{
        "title":"The necktie suffocate only the one who wears it.",
        "desc":"Formality doesn’t require seriousness and high towers. True leadership success means creating a team of leaders who are never afraid of bringing you their problems."
      },
      "6":{
        "title":"Problems are not stop signs.",
        "desc":"Problems are not a sign of failure, rather a tool for assessing the situation and gaining more experience. So we dig for all the possible problems before launching any solution, to ensure that every feature in the product works well."
      },
      "7":{
        "title":"Sailing against the wind.",
        "desc":"It is not reasonable to follow the common practices if you find it out of logic. Certainly what works for others won’t necessarily work for you. The environment in which the theory works is different. The team that will implement this theory is different. So it’s better to draw your way, even if it’s against the flow."
      },
      "8":{
        "title":"Freedom",
        "desc":"Freedom comes with responsibility, and limitation is the first enemy of capabilities. Every team’s player should have the permission to do what he thinks best. A culture of freedom makes them feel okay with mistakes and never satisfied with anything less than innovation."
      },
      "9":{
        "title":"Leadership is for everyone.",
        "desc":"Every team member in Baianat is a decision maker, which means everyone is a core player and a leader when the leader is absent. Because we are working as one towards achieving one goal."
      },
      "10":{
        "title":"There is no stupid question,  but there is a stupid answer.",
        "desc":"Any question that comes out of the someone’s mouth is a result of thinking and analysis of the situation through his personal perspective, and mocking his question is meant to mock this person's decency, and this is not true at all and should not be the ethics of any entity, the mockery is the argument of the weak. Indeed, there is no stupid question, but there is a stupid answer."
      }
    }
  },
  "ar": {
    "pageTitle":"ميثاق بيانات",
    "pageDesc":"التعلم من الماضي والتفكير في المستقبل هذا ما نؤمن به فى بيانات بالإضافة إلى الرؤى والقواعد الأساسية التى تشكل رؤيتنا.",
    "mantra":"الرؤى والمبادئ |التي تميزنا.",
    "insights":{
      "1":{
        "title":"لا علم لمْن لا أخلاق له.",
        "desc":"العمل الذى لا يقوم على أخلاقيات، تكون حقيقته خاوية وفارغة من القيم، ويكون أيضا معرض للتشويه والطعن لضعف حجته."
      },
      "2":{
        "title":"النجاح لا يأتي صدفة، بل نتيجة تعب ومجهود مضني.",
        "desc":"يجب أن يعلم كل لاعب أو محارب فى الفريق أنه يستحيل أن ينجح دون أن يبذل جهد مستحق، فالمثابرة أحيانا بل دائمًا أهم من المهارة."
      },
      "3":{
        "title":"الوقت كالسيف وصف لا يعبر بمصداقية عن مدى أهمية الوقت.",
        "desc":"الوقت اليوم لن يكون مثل وقت الغد أو وقت السنة القادمة، الظروف دومًا متغيرة ومتطورة، لذا عليك عدم الإنتظار إلى الوقت الذي تعتقد أنه مثالي لبدء مشروع ما، فقط إبدأ الأن!"
      },
      "4":{
        "title":"هناك مشكلة، إذن هناك دائما حل، وحل أمثل.",
        "desc":"جميع المشاكل في العالم لها حل بديهي يأتي في عقل أي شخص يبدأ فى التفكير، لكننا دوما نبحث عن الحل المثالي، الحل الذى لا يترك أثر للمشكلة خلفه، بعبارة أخرى لا نماطل، بل نحل المشكلة من جذورها، فنحن لا نرضى بنصف حل، بل حل كامل."
      },
      "5":{
        "title":"ربطة العنق لا تخنق إلا عنق مْن يرتديها فقط.",
        "desc":"ليس ضروري أن يتعامل القائد برسمية، فالقائد الناجح لا يجعل أحد أعضاء الفريق يشعر بأنه أقل منه، فالجميع فريق واحد يسعون إلى تحقيق هدف واحد."
      },
      "6":{
        "title":"المشاكل ليست علامات وقوف، لكنها خطوط إرشادية",
        "desc":"المشاكل ليست علامة على الإخفاق، فهي دليل على السير فى الطريق الصحيح، أو الطريق الخطأ، إذ أنها تعتبر أداة لتقييم الوضع واكتساب المزيد من الخبرات عن طريق التحليل والاستنتاج والمعالجة."
      },
      "7":{
        "title":"عكس المسار أحيانًا، فالنظريات قد تحتمل إثبات العكس",
        "desc":"من غير المعقول أن تسلك طريق ما لمجرد أن مجموعة من الناس قالت هذا هو الطريق الصحيح، بالتأكيد ما يصلح مع غيرك، ليس بالضرورة أن يصلح معك، حيث أن ظروف البيئة التى تعمل فيها النظرية التي يتحدثون عنها مختلفة، فريق العمل الذى سينفذ تلك النظرية مختلف، إذن عليك برسم الطريق الذى تسير فيه بمفردك حتى وإن كان عكس جميع الناس، حتى وإن قال لك الجميع هذا الطريق غير صحيح."
      },
      "8":{
        "title":"الحرية",
        "desc":"الحرية مرتبطة بالمسؤولية والتقييد عدو الإبداع الأول، فالحرية إحساس يجب أن يصل لكل لاعب، إحساس أن لديه الإذن الكامل لعمل ما يراه صحيح من خلال وجهة نظره، أن لن يحدث شيئًا إذا جرب أمر جديد ومختلف، إحساس عدم الرضا بأقل من مبدع."
      },
      "9":{
        "title":"مفهوم الـ معًا.",
        "desc":"عقلان يفكران أفضل من عقل واحد، روح التعاون والترابط بين كل لاعب في الفريق يجب أن تظهر وتطغى بشدة، حتى يحدث الإنسجام والتناغم الذي يساعد الفريق على إحراز الأهداف، فلا مجال للأنانية، إما فريق واحد أو قل وداعًا للنجاح. بعبارة أخرى إنكار الذات من أجل مصلحة الفريق أمر واجب على كل عضو فيه."
      },
      "10":{
        "title":"لا يوجد سؤال غبي، لكْن توجد إجابة غبية.",
        "desc":"أي شخص يقوم بطرح سؤال ما دليل على التفكير والتحليل الذي قام به من وجهة نظره الخاصة، والاستهزاء بسؤاله يعنى الخروج عن حدود اللباقة. وهذا ليس صحيحًا على الإطلاق ولا ينبغى أن يكون مثل هذا التصرف في أخلاقيات أى كيان، فالسخرية هى حجة الضعفاء. فليس هناك سؤال غبى، لكْن توجد إجابة غبية. "
      }
    }
  }
}
</i18n>
